import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { AppSessionService } from '../app-session/app-session.service';

// const DATA_URL = 'http://192.168.1.35:51024/api/v1/categories/elements?usageCode=CUSTOMER';
// const DATA_URL = 'http://192.168.1.35:51024/api/v1/categories/elements';


@Injectable({
  providedIn: 'root'
})
export class MenuService {

  public remoteData: BehaviorSubject<any[]>;
  private BASE_URL = this.appSession.baseUrl + '/api/v1/menu';


  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
    ) {

    this.remoteData = new BehaviorSubject([]);
  }



  getMenus(): Observable<any> {
    const headers = new HttpHeaders({

      'Content-type': 'application/json'
    });
    const url = `${this.appSession.baseUrl + '/api/v1/menu'}`;
    // const url = `${this.appSession.baseUrl + '/api/v1/menu'}`;
    return this.http.get(url, { headers });
  }


}
